import React from "react";
import { TableQuestionsCategory } from "../../components";

const QuestionsCategory = () => {
  return (
    <div>
      <div className="pt-[80px] md:pt-0 px-2 md:px-6 m-2 md:m-10 bg-white rounded-3xl">
        <p className="text-xl mb-4 text-left">Lista Pyetjet me kategori</p>
        <TableQuestionsCategory />
      </div>
    </div>
  );
};

export default QuestionsCategory;
